module.exports = __webpack_public_path__ + "static/media/portip.0bd8e5b5.png";